const constants = {
  REGEX: {
    EMAIL:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
  EMAIL_STATUS: {
    SUCCESS: 'success',
    FAILED: 'failed',
    ALREADY_VERIFIED: 'already_verified',
    LINK_EXPIRED: 'link_expired',
  },
  STATES: [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'District of Columbia',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ],
  ACH_verify_alert:
    'You must verify your bank account before you can use Bento. Please check your bank account for the two verification amounts and enter them on the verification screen.',
  ACH_verify_attempts_left(n: number) {
    return {
      title: 'Verification Failed',
      message: `Incorrect amounts entered. You have ${n} more tries left.`,
    };
  },
  ACH_failed_attempts: {
    title: 'Verification Limit Reached',
    message: 'You have had 5 failed attempts. Please contact Bento at smile@bento.net to proceed.',
  },
  TAX_ID_TYPE_SSN: 'SSN',
  TAX_ID_TYPE_EIN: 'EIN',
  TAX_ID_TYPE_INDIVIDUAL: 'individual',
  TAX_ID_TYPE_COMPANY: 'company',
  TAX_ID_OPTIONS: [
    { value: 'individual', label: 'SSN' },
    { value: 'company', label: 'EIN' },
  ],
  GENDER_CHOICES: [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'third gender', label: 'Third Gender' },
    // { value: "not to say", label: "Prefer Not To Say" },
    // { value: "self describe", label: "Self Describe" }
  ],
  VALIDATION: {
    REQUIRED: 'Required',
    INVALID: 'Invalid',
    TID: 'Must be 9 digits',
    TID4: 'Must be 4 digits',
    PHONE: 'Must be 10 digits',
    ZIP: 'Must be 5 digits',
    MEMBERID: 'Must start with an E followed by 7 digits, e.g., E1234567',
    BANK_ACCOUNT: 'Must be 4 to 17 digits',
    BANK_ACCOUNT_MATCH: 'Bank account numbers must match',
    BANK_ROUTING: 'Must be 9 digits',
    BANK_ROUTING_MATCH: 'Bank routing numbers must match',
    EMAIL: 'Not a valid email',
    PASSWORD: 'Must be at least 6 characters',
    PASSWORD_MATCH: 'Passwords must match',
  },
  ZIP_LENGTH: 5,
  TID_LENGTH: 9,
  TID4_LENGTH: 4,
  PHONE_LENGTH: 10,
  BANK_ACCOUNT_MIN_LENGTH: 4,
  BANK_ACCOUNT_MAX_LENGTH: 17,
  BANK_ROUTING_LENGTH: 9,
  PASSWORD_MIN_LENGTH: 6,
  BANK_STATUS_ACCOUNT_NOT_ADDED: 'BANK_STATUS_ACCOUNT_NOT_ADDED',
  BANK_STATUS_VERIFICATION_PENDING: 'BANK_STATUS_VERIFICATION_PENDING',
  BANK_STATUS_VERIFIED: 'BANK_STATUS_VERIFIED',
  BANK_STATUS_UPDATED_VERIFICATION_PENDING: 'BANK_STATUS_UPDATED_VERIFICATION_PENDING',
  STANDARD_PLAN_PLATINUM_PLUS: 'platinum_high',
  STANDARD_PLAN_PLATINUM_STANDARD: 'platinum_med',
  STANDARD_PLAN_PLATINUM_ESSENTIAL: 'platinum_low',
  STANDARD_PLAN_GOLD_PLUS: 'gold_high',
  STANDARD_PLAN_GOLD_STANDARD: 'gold_med',
  STANDARD_PLAN_GOLD_ESSENTIAL: 'gold_low',
  STANDARD_PLAN_SILVER_PLUS: 'silver_high',
  STANDARD_PLAN_SILVER_STANDARD: 'silver_med',
  STANDARD_PLAN_SILVER_ESSENTIAL: 'silver_low',
  STANDARD_PLAN_TYPES: [
    'platinum_high',
    'platinum_med',
    'platinum_low',
    'gold_high',
    'gold_med',
    'gold_low',
    'silver_high',
    'silver_med',
    'silver_low',
  ],
  NETWORK_PLATINUM: 'platinum',
  NETWORK_GOLD: 'gold',
  NETWORK_SILVER: 'silver',
  NETWORKS: ['platinum', 'gold', 'silver'],
  NETWORKS_MAP: {
    platinum: 'Platinum',
    gold: 'Gold',
    silver: 'Silver',
  },
  SIGNUP_STEP_COMPANY_DETAILS: 'SIGNUP_STEP_COMPANY_DETAILS',
  SIGNUP_STEP_EMAIL_VERIFICATION: 'SIGNUP_STEP_EMAIL_VERIFICATION',
  SIGNUP_STEP_ADD_BANK_ACCOUNT: 'SIGNUP_STEP_ADD_BANK_ACCOUNT',
  SIGNUP_STEP_SELECT_PLANS: 'SIGNUP_STEP_SELECT_PLANS',
  SIGNUP_STEP_SELECT_ENROLLMENT_DATES: 'SIGNUP_STEP_SELECT_ENROLLMENT_DATES',
  SIGNUP_STEP_DONE: 'SIGNUP_STEP_DONE',
  TIP_HAS_UNVERIFIED_BANK: 'This feature is enabled after you verify your bank.',
  TIP_IS_EDI: 'This feature is disabled for companies using EDI.',
} as const;

export type EmployerPortalConstants = typeof constants;

export default constants;
